export default __webpack_public_path__ + "static/media/ciljasusan.5d37acec.jpg";